import React from 'react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { buildingBlocks, IMAGES } from '../data/audit';
export function Author() {
  return <section className="bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-20" data-mp="9t5bzynry5cp">
      <div className="mx-auto w-full max-w-5xl" data-id="element-21" data-mp="9qspr9azh8tu">
        <SectionHeading tone="light" eyebrow="🦷 Meet your author" title="Dr. Karito" subtitle="Turning clinical knowledge into a practical case-review system." data-id="element-22" data-mp="er704y024uv1" />

        <div className="mt-10 grid items-center gap-8 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]" data-id="element-23" data-mp="17fcixf7jw9s8">
          <div className="overflow-hidden rounded-3xl ring-1 ring-white/15" data-id="element-24" data-mp="silhz1i8aq0i">
            <img src={IMAGES.author} alt="Portrait of Dr. Karito in her dental clinic" className="h-full w-full object-cover" loading="lazy" data-id="element-25" data-mp="xholuimh2q6w" />
          </div>

          <div className="space-y-4 text-[15px] leading-relaxed text-cream-100/80 sm:text-base" data-id="element-26" data-mp="3iaa06oeo98q5">
            <p data-id="element-27" data-mp="1tz3r4tqd3fkq">
              Dr. Karito created the Complex Rehab Case Audit™ after recognizing
              a challenge shared by many dentists: the amount of clinical
              information available is enormous — but information alone doesn’t
              create a repeatable process.
            </p>
            <p data-id="element-28" data-mp="1xyucghx4d3hv">
              Complex rehabilitation cases require dentists to consider multiple
              variables, identify important clinical signals and determine what
              deserves additional evaluation. The Audit was designed to make that
              review process easier to organize.
            </p>
            <blockquote className="rounded-2xl border-l-4 border-gold-500 bg-white/[0.05] px-5 py-4" data-id="element-29" data-mp="2lrkmumpdjeq1">
              <p className="font-display text-lg italic leading-snug text-cream-50 sm:text-xl" data-id="element-30" data-mp="2vnxezg59tkio">
                “You don’t always need more information. Sometimes you need a
                better way to review what you already know.”
              </p>
              <footer className="mt-2 text-[11px] font-extrabold uppercase tracking-[0.16em] text-gold-400" data-id="element-31" data-mp="1ocpw5zw0ok5y">
                — Dr. Karito
              </footer>
            </blockquote>
          </div>
        </div>

        <ul className="mt-10 grid grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-32" data-mp="1xas654xqan5d">
          {buildingBlocks.map(b => <li key={b} className="rounded-xl bg-white/[0.06] px-3 py-3 text-center text-[11px] font-extrabold uppercase leading-tight tracking-[0.06em] text-gold-300 ring-1 ring-white/10 sm:text-xs" data-id="element-33" data-mp="224wdhpawox6z">
              {b}
            </li>)}
        </ul>
        <p className="mt-4 text-center text-sm text-cream-100/60" data-id="element-34" data-mp="2g0hxtj672st2">
          Everything organized into one repeatable review system.
        </p>

        <div className="mt-10" data-id="element-35" data-mp="lpczmudvn8l4">
          <CTAButton label="Get Dr. Karito’s clinical audit system" subLabel="$27 one-time · Lifetime access" data-id="element-36" data-mp="lq4m9fphxvz9" />
        </div>
      </div>
    </section>;
}